import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginAdmin } = useAuth(); // AuthContext

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setLoading(true); // Start loading

    try {
      const response = await fetch('/api/admin-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Login failed');
      }

      const data = await response.json();
      console.log('Admin login successful:', data);

      // Store admin data including is_super_admin flag
      loginAdmin(data.admin_email, data.is_super_admin, data.admin_id); // Store in AuthContext
      navigate('/company-admin-home'); // Redirect
    } catch (error) {
      console.error('Error in login request:', error);
      setErrorMessage(error.message || 'An error occurred during login');
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <form className="hw-login-form" onSubmit={handleSubmit}>
      <div className="hw-input-group">
        <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/5c6a28c04ec51b8fc11cdf661362a6d97b44fd42b6a33e5528bd359c8ffbab84?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803" alt="Email icon" className="hw-input-icon" />
        <input
          type="email"
          placeholder="Email"
          aria-label="Email"
          className="hw-form-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="hw-input-group">
        <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/4eaeb393e3e4c9afbbee777fd3c893ba7177c52e0b4352975c50b0730cd97b3d?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803" alt="Password icon" className="hw-input-icon" />
        <input
          type="password"
          placeholder="Password"
          aria-label="Password"
          className="hw-form-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      {errorMessage && <div className="error-message">{errorMessage}</div>}

      <button type="submit" className="hwu-login-button" disabled={loading}>
        {loading ? 'Logging in...' : 'Login Now'}
      </button>
    </form>
  );
}

export default LoginForm;
